import { render, staticRenderFns } from "./Singleblogtitle.vue?vue&type=template&id=650e6097&scoped=true&"
import script from "./Singleblogtitle.vue?vue&type=script&lang=js&"
export * from "./Singleblogtitle.vue?vue&type=script&lang=js&"
import style0 from "./Singleblogtitle.vue?vue&type=style&index=0&id=650e6097&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e6097",
  null
  
)

export default component.exports